import React from 'react'
import { useSelector } from 'react-redux';
import ChanceStepDescInfo from '../../../components/chancemng/stepper/ChanceStepDescInfo';

const ChanceStepInfoContainer = () => {
    const { chance } = useSelector(({ chanceModule }) => ({
        chance: chanceModule.chance.chance,
    }));

    return (
        <ChanceStepDescInfo chance={chance}/>
    )
}

export default ChanceStepInfoContainer